import React, { createContext, useContext, useState, useEffect } from "react";

const BusinessContext = createContext();

export const useBusinessContext = () => useContext(BusinessContext);

export const BusinessProvider = ({ children }) => {
    const [selectedBusiness, setSelectedBusiness] = useState(() => {
        // Load selected business from local storage on initialization
        const storedBusiness = localStorage.getItem("selectedBusiness");
        return storedBusiness ? JSON.parse(storedBusiness) : null;
    });

    useEffect(() => {
        // Save selected business to local storage whenever it changes
        if (selectedBusiness) {
            localStorage.setItem("selectedBusiness", JSON.stringify(selectedBusiness));
        } else {
            localStorage.removeItem("selectedBusiness");
        }
    }, [selectedBusiness]);

    return (
        <BusinessContext.Provider value={{ selectedBusiness, setSelectedBusiness }}>
            {children}
        </BusinessContext.Provider>
    );
};




// import React, { createContext, useState, useContext } from "react";

// const BusinessContext = createContext();

// export const useBusinessContext = () => useContext(BusinessContext);

// export const BusinessProvider = ({ children }) => {
//     const [selectedBusiness, setSelectedBusiness] = useState(null);

//     return (
//         <BusinessContext.Provider value={{ selectedBusiness, setSelectedBusiness }}>
//             {children}
//         </BusinessContext.Provider>
//     );
// };
